<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Etiqueta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="modelo == 'marcacao' && objeto && objeto.nome_paciente">
                            {{ objeto.nome_paciente }}
                        </div>

                        <az-empty-state v-if="!etiqueta_layouts || !etiqueta_layouts.length" msg="Nenhum layout de etiqueta cadastrado." />

                        <az-input
                            v-else
                            icon="fa fa-tags"
                            placeholder="Selecione o Layout..."
                            type="select"
                            :optionsList="etiqueta_layouts"
                            optionsData="id_etiqueta_layout"
                            optionsDisplay="search"
                            v-model="layout" />
              
                            <template v-if="checar_epl()">
                                <div class="small text-muted mt-2">
                                    Servidor de impressão.
                                </div>
                                <input type="text" class="form form-control" v-model="servidor_impressao" />
                            </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" :disabled="!layout" @click="imprimir()">Imprimir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzInput from './forms/AzInput.vue';

export default {
    data() { 
        return { 
            modelo: "",
            etiqueta_layouts: [], 
            layout: "", 
            objeto: null,
            servidor_impressao: "",
            chave_primaria_modelo: "",
        };
    },

    props: ['sufixo'], 

    components: { 
        AzEmptyState, 
        AzInput, 
    },

    computed: { 
        modal_name: function () { 
            return 'emitirEtiquetaModal' + (this.sufixo ? this.sufixo : '');
        }
    },

    methods: { 

        imprimir() { 
            this.$util.setCookie('etiqueta-layout-' + this.modelo, this.layout);

            $('#' + this.modal_name).modal('hide');

            let campo = this.chave_primaria_modelo ? this.chave_primaria_modelo : 'id_' + this.modelo;

            let urlImpressao = 'imprimir/etiqueta/' + this.objeto[campo] + '/' + this.layout; 
            
            if(this.servidor_impressao) {
                urlImpressao +=  '/' + this.servidor_impressao;
            }
            
            this.$util.print_preview(urlImpressao, true);
        },
    
        emitir(modelo, objeto, chave_primaria_modelo = "") { 

            this.objeto = objeto;
            
            $('#' + this.modal_name).modal('show');

            if ( this.modelo != modelo ) { 

                this.etiqueta_layouts = [];

                this.$util.load(this, { 
                    service: 'etiqueta_layouts',
                    func: 'index',
                    parms: { 
                        where: { 
                            st_model_type: 'App\\azure\\' + modelo,
                        }
                    },
                    loadTo: res => { 
                        this.modelo = modelo;
                        this.chave_primaria_modelo = chave_primaria_modelo ? chave_primaria_modelo : 'id_' + this.modelo;
                        this.etiqueta_layouts = res;

                        if ( res && res.length == 1 )
                            this.layout = res[0].id_etiqueta_layout;
                        else 
                            this.layout = this.$util.getCookie('etiqueta-layout-' + this.modelo);

                        
                    }
                });

            }

        },

        checar_epl() {
            
            if(this.layout) {
                const layout = this.etiqueta_layouts.find(layout => layout.id_etiqueta_layout == this.layout);
                
                if(layout.ch_tipo_impressao == 'S' && layout.fl_layout_html) {
                    return true;
                }
            }

            return false;

        }

    },

    mounted() {
        this.servidor_impressao = this.$util.getCookie('lab_servidor_impressao');  
    },
}
</script>